const es = {
    language: {
        label: 'Idioma',
        heading: 'Idioma de visualización',
        help: 'Elija el idioma de menús, botones, etiquetas, Ayuda y encabezados de informes en BistroAdmin. Esto es solo para este navegador y no cambia el POS, la app de nómina, los mensajes a clientes, el formato de dinero ni las horas del comercio.',
        posHeading: 'Idioma de visualización del POS',
        posHelp: 'Este idioma se usa en todos los terminales POS de esta tienda. Es independiente del idioma de BistroAdmin de arriba. Si no está definido o no se reconoce, se usa inglés. Cambiarlo no bloquea el inicio de sesión, el fichaje ni las ventas.',
        posLabel: 'Idioma del POS',
        posSave: 'Guardar idioma del POS',
    },
    common: {
        cancel: 'Cancelar',
        save: 'Guardar',
        saving: 'Guardando…',
        refresh: 'Actualizar datos',
        loading: 'Cargando…',
        add: 'Agregar',
        edit: 'Editar',
        delete: 'Eliminar',
        open: 'Abrir',
        yes: 'Sí',
        no: 'No',
        confirm: '¿Está seguro?',
        name: 'Nombre',
        status: 'Estado',
        actions: 'Acciones',
        action: 'Acción',
        image: 'Imagen',
        active: 'Activo',
        archived: 'Archivado',
        default: 'Predeterminado',
        connected: 'Conectado',
        notConnected: 'No conectado',
        required: 'Obligatorio',
        optional: 'Opcional',
        update: 'Actualizar',
    },
    nav: {
        products: 'Productos',
        workPeriods: 'Periodos de trabajo',
        users: 'Usuarios',
        settings: 'Ajustes',
        help: 'Ayuda',
        logOut: 'Cerrar sesión',
        toggle: 'Mostrar u ocultar navegación',
        logoAlt: 'Bistro Admin',
    },
    header: {
        refreshToast: 'Actualizando datos...',
        merchantUnavailable: 'La información del comercio no está disponible.',
    },
    login: {
        title: 'Inicie sesión en su cuenta',
        username: 'Usuario',
        usernamePlaceholder: 'Ingrese el usuario',
        password: 'Contraseña',
        passwordPlaceholder: 'Ingrese la contraseña',
        submit: 'Iniciar sesión',
        submitting: 'Iniciando sesión…',
        logoAlt: 'Bistro Admin',
    },
    settingsTabs: {
        store: 'Tienda',
        stations: 'Estaciones',
        customerScreen: 'Pantalla del cliente',
        layouts: 'Diseños',
        integrations: 'Integraciones',
        system: 'Sistema',
        payroll: 'Nómina',
        payout: 'Pagos',
    },
    productsTabs: {
        categories: 'Categorías',
        products: 'Productos',
        menus: 'Menús',
        export: 'Exportar',
        import: 'Importar',
        exportTitle: 'Exportar todos los productos y categorías',
        importTitle: 'Importar productos y categorías desde un archivo',
        merchantUnavailable: 'La información del comercio no está disponible. Actualice la página o inicie sesión de nuevo.',
        exportFormat: 'Formato de exportación',
        exportChoose: 'Elija un formato para exportar sus productos y categorías:',
        importFormat: 'Formato de importación',
        importChoose: 'Elija el formato del archivo que desea importar:',
        excel: 'Excel (.xlsx)',
        json: 'JSON (.json)',
        confirmImport: 'Confirmar importación',
        aboutToImport: 'Va a importar:',
        categoriesCount: '{count} categorías',
        productsCount: '{count} productos',
        variationsCount: '{count} variaciones',
        optionsCount: '{count} opciones',
        importNote: 'Las categorías que ya existen se omitirán. Los productos se crearán como artículos nuevos.',
        exportedOn: 'Exportado el: {date}',
        importing: 'Importando productos...',
        categoriesTitle: 'Categorías',
        categoryName: 'Nombre de categoría',
        items: 'Artículos',
        printer: 'Impresora',
        addCategory: 'Agregar categoría',
        editCategory: 'Editar categoría',
        changeImage: 'Cambiar',
        addIcon: 'Agregar icono',
        productsTitle: 'Productos',
        product: 'Producto',
        category: 'Categoría',
        variationsShort: 'Var.',
        priceUsd: 'Precio($)',
        inStock: 'En existencias',
        sku: 'SKU',
        menusTitle: 'Menús',
        menusIntro: 'Los menús con nombre filtran el catálogo del POS. Importar/exportar no incluye menús. Predeterminado para todas las estaciones: {default} (las estaciones pueden anularlo en Ajustes → Estaciones).',
        menusIntroSchedule: ' Abra un menú para editar sus horarios.',
        showArchived: 'Mostrar archivados',
        autoScheduleOn: 'Programación automática activada',
        useAutoSchedule: 'Usar programación automática',
        autoScheduleTitle: 'Activar la programación automática. Las ventanas coincidentes sustituyen el predeterminado. Si no hay ventana, el POS usa el predeterminado seleccionado (o Todos si no hay). Pulse de nuevo para desactivarla.',
        autoScheduleOnTitle: 'Desactivar la programación automática. El menú predeterminado seleccionado se conserva.',
        autoScheduleWithFallback: 'Programación automática (si no hay ventana: {default})',
        clearDefault: 'Quitar predeterminado (Todos)',
        addMenu: 'Agregar menú',
        noMenus: 'Aún no hay menús. Cree Desayuno / Almuerzo / Cena para filtrar el catálogo del POS. Hasta entonces, el POS muestra el catálogo completo.',
        menuNameRequired: 'El nombre del menú es obligatorio.',
        order: 'Orden',
        autoSchedule: 'Programación automática',
        allFullCatalog: 'Todos (catálogo completo)',
        editMenu: 'Editar menú',
        sortOrder: 'Orden de clasificación',
        moveUp: 'Subir',
        moveDown: 'Bajar',
        setDefault: 'Definir predeterminado',
        setDefaultTitle: 'Las estaciones sin anulación cargan este menú. Con Auto activado, también se usa cuando no hay ventana.',
        archive: 'Archivar',
        restore: 'Restaurar',
        internal: 'Interno',
        fromCategory: 'De la categoría',
    },
    usersChrome: {
        people: 'Personas',
        name: 'Nombre',
        phone: 'Teléfono',
        email: 'Correo electrónico',
        roleType: 'Tipo de rol',
        role: 'Rol',
        stripeTips: 'Pagos de propinas Stripe',
        addPeople: 'Agregar persona',
        editPeople: 'Editar persona',
        id: 'ID',
        phoneShort: 'Teléfono',
        created: 'Creado',
        tips: 'Propinas',
        pin: 'PIN de 4 dígitos',
        pinHelp: '4 dígitos, no puede empezar por 0',
        pinPlaceholder: 'ej. 1234',
        payroll: 'Nómina',
        receivesHourlyWage: 'Recibe salario por hora',
        hourlyRate: 'Tarifa por hora',
        hourlyRequired: 'Obligatorio cuando el salario por hora está activo.',
        nonHourlyHelp: 'El personal no por hora se excluye de la sincronización de horas de salario.',
        tipsInPayroll: 'Propinas y gratificación en la nómina',
        inheritDefault: 'Usar el valor predeterminado del comercio',
        alwaysInclude: 'Incluir siempre (propinas y gratificación impagas)',
        neverInclude: 'Nunca incluir',
        merchantDefaultHelp: 'El valor predeterminado del comercio se define en Ajustes → Nómina.',
        stripeDisabled: 'Los pagos de propinas están desactivados en Ajustes de tienda. No hay enlaces de configuración Stripe para este comercio.',
        stripeAfterCreate: 'Tras crear este usuario, puede enviar un enlace de alta de Stripe o vincular una cuenta Stripe existente.',
    },
    workperiods: {
        end: 'Finalizar periodo de trabajo',
        ending: 'Finalizando...',
        start: 'Iniciar periodo de trabajo',
        starting: 'Iniciando...',
        period: 'Periodo',
        trans: 'Trans.',
        charges: '*NETO',
        net: 'NETO TARJETA',
        fees: 'Tarifas',
        adminFees: 'Tarifas admin',
        items: 'Artículos',
        card: 'Tarjeta',
        cash: 'Efectivo',
        tipsCard: 'Propinas (tarjeta)',
        tipOuts: 'Salidas de propina',
        ref: 'Ref.',
        netSalesMerch: 'Ventas después de reembolsos',
        tax: 'Impuesto',
        grat: 'Grat.',
        startDate: 'Fecha de inicio',
        endDate: 'Fecha de fin',
        active: 'Activo',
        search: 'Buscar',
        searchPlaceholder: 'Periodo (ej. lun) o importe...',
    },
    payroll: {
        heading: 'Nómina',
        intro: 'Configure cómo este comercio prepara al personal para la nómina. El salario por hora y las anulaciones de propina por empleado se definen en Usuarios. Finalizar un ciclo en Rebelity Payroll puede marcar propinas impagas como pagadas (sin transferencia Stripe). Si Check payroll está activo, las propinas impagas se marcan pagadas solo después de que el ACH de salarios de Check se complete.',
        loading: 'Cargando ajustes de nómina…',
        enable: 'Activar nómina para este comercio',
        includeTips: 'Incluir propinas y gratificación en la nómina (predeterminado del comercio)',
        engine: 'Motor de nómina',
        engineFallback: 'Ingrese la URL base privada del motor de nómina y luego guarda.',
        baseUrl: 'URL base del motor de nómina',
        apiKey: 'Clave API (opcional)',
        keySaved: 'Clave guardada — déjela en blanco para conservarla',
        engineHelp: 'El navegador nunca llama al motor de nómina. POSApi usa esta URL para sincronizar horas/propinas y tablas fiscales. Use un host al que el servidor de API pueda llegar (no localhost de su laptop en EB compartido).',
        connecting: 'Conectando…',
        saveTest: 'Guardar y probar conexión',
        openPayroll: 'Abrir nómina',
        save: 'Guardar ajustes de nómina',
        checkPayroll: 'Nómina Check',
        loadingCheck: 'Cargando estado de Check…',
        manageIntegrations: 'Administrar en Integraciones',
        integrations: 'Integraciones',
        payrollStates: 'Estados de nómina',
        taxHeading: 'Stripe Tax (impuesto sobre ventas) · Fase 5a',
        taxIntro: 'Impuesto sobre ventas a cargo del comercio mediante Stripe Tax para plataformas (valores piloto de Atlanta / GA). Es independiente de los impuestos laborales de la nómina. Registre ubicaciones en el Dashboard de Stripe de la cuenta conectada.',
        saveTax: 'Guardar ajustes de Stripe Tax',
        recording: 'Registrando…',
        recordRemit: 'Registrar remesa',
        offlineTaxMode: 'Modo de impuesto offline / efectivo (T2)',
        taxApiDefault: 'API de impuestos + transacciones (predeterminado)',
        stripeChannelsOnly: 'Solo canales Stripe (sin transacciones de impuesto en efectivo)',
    },
    report: {
        employeeSalesTitle: 'Informe de ventas del empleado',
        workPeriodTitle: 'Informe de ventas del periodo de trabajo',
        workPeriodDetail: 'Detalle del periodo de trabajo',
        employee: 'Empleado',
        store: 'Tienda',
        period: 'Periodo',
        generated: 'Generado',
        summary: 'Resumen',
        value: 'Valor',
        shifts: 'Turnos',
        hours: 'Horas',
        totalSales: 'Ventas totales',
        tips: 'Propinas',
        gratuity: 'Gratificación',
        earnings: 'Ganancias',
        cash: 'Efectivo',
        card: 'Tarjeta',
        member: 'Miembro',
        fees: 'Tarifas',
        tipsOwed: 'Propinas adeudadas',
        tipsPaid: 'Propinas pagadas',
        totalTipsAndGrat: 'Total propinas y grat.',
        yourShare: 'Su parte',
        pooledWorkPeriods: 'Periodos con propinas agrupadas',
        saleTimeWorkPeriods: 'Periodos sin propinas agrupadas',
        totalTipsGratExplainer: 'Total propinas y grat. es el total de propinas y gratificación del periodo de trabajo para todos los empleados.',
        payoutExplainer: 'Si no ha conectado su cuenta bancaria a nuestro sistema a través de Stripe, no puede recibir el pago directamente. En su lugar, nuestras propinas se enviarán al gerente de turno designado y esa persona debe pagarle. Todos los pagos de fin de semana están disponibles el miércoles o el jueves siguiente.',
        overview: 'Resumen general',
        salesBreakdown: 'Desglose de ventas',
        tipPayouts: 'Pagos de propinas',
        summaryFor: 'Resumen para {range}',
        noShiftsIn: 'No hay turnos en {range}',
        date: 'Fecha',
        status: 'Estado',
        clockIn: 'Entrada',
        clockOut: 'Salida',
        field: 'Campo',
        time: 'Tiempo',
        sales: 'Ventas',
        tipsEarnings: 'Propinas y ganancias',
        payoutStatus: 'Estado de pago',
        totalHours: 'Horas totales',
        cashSales: 'Ventas en efectivo',
        cardSales: 'Ventas con tarjeta',
        memberSales: 'Ventas de miembro',
        totalEarnings: 'Ganancias totales',
        shift: 'Turno',
        sheetSummary: 'Resumen',
        sheetWorkPeriods: 'Periodos de trabajo',
        none: 'Ninguno',
        stillActive: 'Aún activo',
        employeeSalesHeading: 'Ventas de {name}',
        employeeSalesSubtitle: 'Ver ventas, propinas y horas de trabajo',
        export: 'Exportar',
        exporting: 'Exportando…',
        exportTitle: 'Exportar informe filtrado',
        emailPdf: 'Enviar PDF a {email}',
        noEmail: 'Sin correo en el archivo',
        textPdf: 'Enviar enlace PDF a {phone}',
        noPhone: 'Sin teléfono en el archivo',
        pdf: 'PDF (.pdf)',
        csv: 'CSV (.csv)',
        excel: 'Excel (.xlsx)',
        paid: 'Pagado',
        pending: 'Pendiente',
        transferId: 'ID de transferencia',
        hrs: 'h',
        afterRefunds: 'Después de reembolsos',
        salesBeforeRefunds: 'Ventas antes de reembolsos',
        salesAfterRefunds: 'Ventas después de reembolsos',
        discounts: 'Descuentos',
        comps: 'Cortesías',
        merchRefunds: 'Reembolsos de mercancía',
        merchRefundsHelp: 'Los reembolsos de mercancía son solo el costo del artículo (comida y bebida devuelta). No incluyen impuesto, tarifas, propinas ni gratificación.',
        netSalesMerch: 'Ventas después de reembolsos',
        customerRefunds: 'Reembolsos al cliente (cargo)',
        customerRefundsHelp: 'Los reembolsos al cliente son el cargo completo devuelto al cliente: mercancía más cualquier impuesto, tarifa, propina, gratificación u otros montos revertidos.',
        taxCollected: 'Impuesto recaudado',
        taxRefunded: 'Impuesto reembolsado',
        taxNet: 'Impuesto neto',
        taxNetHelp: 'Impuesto neto = impuesto recaudado − impuesto reembolsado. El impuesto no está incluido en Ventas antes de reembolsos ni en Ventas después de reembolsos.',
        netTips: 'Propinas netas',
        netGratuity: 'Gratificación neta',
        refundNetFootnote: 'Ventas después de reembolsos = ventas antes de reembolsos − reembolsos de mercancía. Los reembolsos del cargo al cliente (impuesto, propina, tarifa) se listan por separado y no se restan otra vez de las ventas después de reembolsos.',
        refundEstimateFootnote: 'Algunos reembolsos fueron solo por monto (sin cantidades de ítems). Las partes de mercancía y propina/gratificación son estimadas — confirme con el recibo de reembolso del POS si es necesario.',
    },
    store: {
        details: 'Datos de la tienda',
        wpStart: 'Hora de inicio del periodo',
        wpEnd: 'Hora de fin del periodo',
        wpEndHelp: 'Si se define, los periodos abiertos terminan a esta hora local de la tienda. El personal en POS recibe avisos de 15/5/1 minutos con sonido; el cierre automático espera a que se cierren todas las cuentas.',
        name: 'Nombre de la tienda',
        type: 'Tipo de tienda',
        email: 'Correo electrónico',
        phone: 'Teléfono',
        address: 'Dirección',
        useAccountDefault: 'Usar predeterminado de la cuenta',
        street: 'Calle',
        city: 'Ciudad',
        state: 'Estado',
        zip: 'C.P.',
        description: 'Descripción de la tienda',
        descriptionPlaceholder: 'Ingrese una breve descripción de su tienda',
        receiptFooter: 'Texto al pie del recibo',
        receiptFooterHelp: 'Este texto aparecerá al final de los recibos impresos',
        tipPayoutRouting: 'Enrutamiento de pagos de propinas',
        tipModeMerchant: 'Las propinas van al comercio — los empleados se pagan por otros medios',
        tipModeDisabled: 'Los pagos de propinas están desactivados — no se usarán enlaces ni transferencias Stripe de empleados',
        tipModePlatform: 'Propinas retenidas en la plataforma — transferidas automáticamente a los empleados vía Stripe',
        tipRoutingMode: 'Modo de enrutamiento de propinas',
        optionPlatform: 'Plataforma (transferencia automática a empleados)',
        optionMerchant: 'Cuenta del comercio (el comercio paga a los empleados)',
        optionDisable: 'Desactivar pagos de propinas',
        saveDetails: 'Guardar datos de la tienda',
        image: 'Imagen de la tienda',
        imageDefault: '*Si no se especifica, se usa la imagen de la cuenta del cliente',
        change: 'Cambiar',
        addImage: 'Agregar imagen',
        saveImage: 'Guardar imagen de la tienda',
        storeAlt: 'Tienda',
    },
    stations: {
        heading: 'Estación:',
        intro: 'Cree estaciones para asignar a terminales',
        name: 'Nombre de la estación',
        namePlaceholder: 'Estación de servidor',
        terminal: 'Terminal',
        unassigned: 'Sin asignar',
        save: 'Guardar estación',
        note: 'Nota:',
        noteBody: 'Las terminales solo se pueden asignar a estaciones en BistroPOS. Una vez creada una estación aquí, asigne una terminal en el menú Ajustes y la pestaña Terminales de la aplicación Bistro.',
        available: 'Estaciones disponibles',
        menu: 'Menú',
        deleteConfirm: '¿Eliminar estación?',
        editName: 'Editar nombre de estación',
        inherit: 'Heredar el predeterminado del comercio',
        autoSchedule: 'Programación automática',
        allCatalog: 'Todo (catálogo completo)',
        menuHelp: 'Las anulaciones se aplican en Bistro / kiosco para esta estación. Los cajeros pueden cambiar de menú hasta cerrar sesión. Automático usa las ventanas de horario de cada menú (hora local del comercio).',
        layout: 'Diseño',
        layoutHelp: 'Con el modo de diseño activado, esta estación abre el plano seleccionado. Puede elegir cualquier diseño activo del salón de la cuenta.',
    },
    excel: {
        sheetCategories: 'Categorías',
        sheetProducts: 'Productos',
        name: 'Nombre',
        printerId: 'PrinterId',
        picture: 'Imagen',
        internalOnly: 'SoloInterno',
        categoryName: 'NombreCategoria',
        description: 'Descripción',
        sku: 'SKU',
        barcode: 'Código de barras',
        price: 'Precio',
        feeOption: 'OpcionTarifa',
        taxRate: 'TasaImpuesto',
        inventory: 'Inventario',
        variations: 'Variaciones',
        options: 'Opciones',
        missingCategories: 'Falta la hoja "Categories" o "Categorías" en el libro',
        missingProducts: 'Falta la hoja "Products" o "Productos" en el libro',
    },
    system: {
        loadFailed: 'No se pudieron cargar los ajustes del sistema.',
        notificationLoadFailed: 'No se pudieron cargar los ajustes de notificación al cliente.',
        loadingSettings: 'Cargando ajustes del sistema…',
        loadingNotifications: 'Cargando valores predeterminados de notificación…',
        deliveryHeading: 'Envío automático del informe de turno',
        deliveryIntro: 'Si está activado, los empleados reciben automáticamente el informe de ventas del periodo de trabajo cuando cierran turno en el POS, o cuando un periodo finalizado los saca automáticamente. Los envíos manuales desde Ventas de empleados no cambian.',
        smsToggle: 'Enviar informe de turno por SMS al cerrar turno',
        smsHelp: 'Envía un enlace PDF por SMS cuando el empleado tiene un teléfono registrado.',
        emailToggle: 'Enviar informe de turno por correo al cerrar turno',
        emailHelp: 'Envía un enlace PDF por correo cuando el empleado tiene un correo registrado.',
        deliveryNotConfigured: 'El envío por {channel} no está configurado en este entorno. Puede guardar el interruptor, pero los informes no se enviarán hasta que se configure el envío.',
        saveDelivery: 'Guardar envío de informes',
        pooledHeading: 'Propinas mancomunadas',
        pooledIntro: 'Si está activado, las propinas y la gratificación se comparten por sesión de reloj (vea el informe de propinas mancomunadas) y Stripe paga partes iguales al finalizar el periodo de trabajo, o con Pagar propinas mancomunadas en el detalle de un periodo finalizado. Las transferencias por empleado al momento de la venta se omiten mientras esto esté activo. Requiere modo de enrutamiento de propinas = comisión de la plataforma. Desactívelo solo después de pagar los periodos pendientes. El resumen de cierre no cambia.',
        pooledToggle: 'Propinas mancomunadas',
        pooledHelp: 'Las propinas y la gratificación se comparten entre los empleados con el rol User que estaban fichados cuando ocurrió cada venta. Los PIN solo Admin o solo Manager no reciben parte, aunque fichen o registren la venta. Un PIN que también tiene el rol User sí participa. Si ningún empleado con rol User estaba fichado, esa propina permanece en la plataforma. Al cerrar turno se congela la parte de esa persona. La liquidación se ejecuta al finalizar el periodo; use Pagar propinas mancomunadas en periodos finalizados para reintentar. Las propinas ya pagadas al momento de la venta (antes de activar el mancomunado) se excluyen del fondo.',
        savePooled: 'Guardar propinas mancomunadas',
        payoutSmsHeading: 'Mensaje de pago de propinas',
        payoutSmsIntro: 'Si está activado, el empleado recibe un solo mensaje cuando un pago llega a su propia cuenta de Stripe. Las propinas en tiempo real no envían un mensaje por cada venta.',
        payoutSmsToggle: 'Enviar un mensaje al empleado cuando el pago llega a su cuenta de Stripe',
        payoutSmsHelp: 'El mensaje usa el idioma del POS de la tienda. Indica el importe pagado a Stripe y que debería llegar a su cuenta bancaria en 2 días hábiles. No se envía cuando el pago va al gerente designado, ni otra vez por el mismo periodo de trabajo.',
        savePayoutSms: 'Guardar mensaje de pago',
        notificationsHeading: 'Valores predeterminados de notificación al cliente',
        notificationsIntro: 'Valores del comercio para Quick Serve y notificaciones automáticas de pedido listo. Las estaciones pueden anularlos en Ajustes avanzados del POS; use restablecer para borrar todas las anulaciones de estación.',
        quickServeToggle: 'Activar flujo Quick Serve de forma predeterminada',
        quickServeHelp: 'Si está activado, las estaciones nuevas heredan Quick Serve de pago primero, salvo que lo anulen. Las estaciones en modo Lote (Bar) nunca usan Quick Serve.',
        autoSmsToggle: 'Enviar SMS automáticamente cuando el pedido esté listo',
        autoSmsHelp: 'Envía un SMS automáticamente cuando KDS marca el pedido como completo, si la cuenta tiene un teléfono.',
        autoEmailToggle: 'Enviar correo automáticamente cuando el pedido esté listo',
        autoEmailHelp: 'Envía un correo automáticamente cuando KDS marca el pedido como completo, si la cuenta tiene un correo.',
        defaultMessageLabel: 'Mensaje predeterminado de pedido listo',
        defaultMessageHelp: 'Se usa para SMS y correo automáticos cuando una estación no tiene su propio mensaje.',
        saveNotifications: 'Guardar notificaciones predeterminadas',
        resetStations: 'Restablecer anulaciones de todas las estaciones',
        workPeriodHeading: 'Mantenimiento de periodos de trabajo',
        workPeriodIntro: 'Conciliar periodos finalizados para cerrar el turno de usuarios que siguen activos después de que su periodo terminó. Los periodos abiertos no se ven afectados.',
        workPeriodHelp: 'La conciliación no envía informes de turno automáticamente.',
        reconcile: 'Conciliar periodos de trabajo finalizados',
        reconcileTitle: 'Conciliar periodos de trabajo finalizados',
        reconcileBody: 'Esto cerrará el turno de los usuarios que sigan activos en periodos que ya terminaron, usando la hora de fin de ese periodo.',
        reconcileHelp: 'Los periodos abiertos no se verán afectados. Los usuarios que ya cerraron turno no cambiarán.',
        reconciling: 'Conciliando…',
        resetTitle: 'Restablecer anulaciones de notificación de estación',
        resetBody: 'Esto borra las anulaciones de Quick Serve y de notificación automática en todas las estaciones de este comercio. Las estaciones heredarán estos valores predeterminados.',
        resetHelp: 'También se borrarán los mensajes de pedido listo específicos de cada estación.',
        resetting: 'Restableciendo…',
        resetConfirm: 'Restablecer todas las estaciones',
    },
    productEdit: {
        details: 'Detalles del producto',
        productAlt: 'Producto',
        change: 'Cambiar',
        addImage: 'Agregar imagen',
        name: 'Nombre del producto',
        price: 'Precio (en $)',
        cardFee: 'Opciones de cargo de tarjeta',
        sku: 'SKU',
        internalOnly: 'Solo artículo interno',
        internalInherited: 'Este artículo hereda Solo artículo interno de su categoría. Muévalo a otra categoría para sincronizarlo con tiendas en línea.',
        internalHelp: 'Manténgalo solo en POS y BistroAdmin. No se sincronizará con tiendas en línea u otros canales.',
        taxRate: 'Tasa de impuesto %',
        stripeTax: 'Categoría fiscal de Stripe',
        inheritDefault: 'Heredar predeterminado ({code})',
        food: 'Alimentos ({code})',
        alcohol: 'Alcohol ({code})',
        merchandise: 'Mercancía ({code})',
        custom: 'Personalizado ({code})',
        description: 'Descripción del producto',
        saveDetails: 'Guardar detalles del producto',
        addVariations: 'Agregar variaciones',
        variation: 'Variación',
        priceShort: 'Precio',
        stock: 'Existencias',
        onHand: 'En mano',
        addAnotherVariation: 'Agregar otra variación',
        addOptions: 'Agregar opciones',
        option: 'Opción',
        fromCategory: 'De la categoría',
        fromCategoryTitle: 'Aplicado desde la plantilla de categoría',
        trackStock: 'Controlar existencias',
        on: 'Sí',
        off: 'No',
        remove: 'Quitar',
        addAnotherOption: 'Agregar otra opción',
        manageInventory: 'Administrar inventario',
        totalStock: 'Existencias totales (suma de variaciones):',
        variationStockHelp: 'Edite las existencias en cada fila de variación. El inventario del producto no se usa mientras existan variaciones.',
        availableStock: 'Existencias disponibles',
        saveInventory: 'Guardar inventario',
    },
    stripe: {
        heading: 'Pagos de propinas Stripe',
        connected: 'Conectado',
        pending: 'Alta pendiente',
        restricted: 'Restringido',
        disabled: 'Desactivado',
        notConnected: 'No conectado',
        linkedExisting: 'Cuenta existente vinculada',
        platformCreated: 'Cuenta creada en la plataforma',
        enterAccountId: 'Ingrese un ID de cuenta Stripe para vincular.',
        acctPrefix: "Los ID de cuenta Stripe deben empezar por 'acct_'.",
        disabledHelp: 'Los pagos de propinas están desactivados en Ajustes de tienda. Active un modo de enrutamiento antes de enviar enlaces o vincular cuentas Stripe.',
        chooseHow: 'Elija cómo conectar a este empleado para el pago de propinas:',
        createNew: 'Crear nueva',
        linkExisting: 'Vincular existente',
        sendOnboard: 'Envíe un enlace de alta al empleado para crear una cuenta Stripe:',
        sendTo: 'Enviar a {dest}',
        noEmail: 'Sin correo electrónico',
        noPhone: 'Sin teléfono',
        emailLink: 'Enlace por correo',
        textLink: 'Enlace por SMS',
        addContact: 'Agregue correo o teléfono para enviar el enlace de alta.',
        linkExistingHelp: 'Vincule una cuenta Stripe conectada que ya esté en esta plataforma.',
        linkAccount: 'Vincular cuenta Stripe',
        disabledOnboard: 'Los pagos de propinas están desactivados en Ajustes de tienda, por lo que no hay enlaces de alta.',
        resend: 'Reenviar enlace de alta:',
        email: 'Correo',
        text: 'SMS',
        refresh: 'Actualizar',
        removeConfirm: '¿Quitar esta cuenta Stripe? El empleado deberá configurarse de nuevo para recibir propinas.',
        removeAccount: 'Quitar cuenta Stripe',
        incomplete: 'El alta de Stripe está incompleta. El empleado debe terminar la configuración para recibir propinas.',
        autoPayout: 'Pago automático de propinas:',
        enabled: 'Activado',
        disabledBtn: 'Desactivado',
        viewDashboard: 'Ver Dashboard de Stripe',
        disconnect: 'Desconectar',
        restrictedHelp: 'La cuenta Stripe tiene restricciones. El usuario debe actualizar su información en Stripe.',
        fixOnStripe: 'Corregir en Stripe',
    },
    toast: {
        exportedJson: 'Se exportaron {products} productos y {categories} categorías (JSON)',
        exportedExcel: 'Se exportaron {products} productos y {categories} categorías (Excel)',
        invalidFile: 'Archivo no válido: {errors}',
        parseJson: 'No se pudo leer el archivo. Seleccione un JSON de exportación válido.',
        parseExcel: 'No se pudo leer el archivo Excel: {message}',
        importStarting: 'Iniciando importación...',
        catsCreated: '{count} categorías creadas',
        catsExisted: '{count} categorías ya existían',
        prodsCreated: '{count} productos creados',
        varsCreated: '{count} variaciones creadas',
        optsCreated: '{count} opciones creadas',
        imagesFailed: '{count} imágenes no se pudieron transferir',
        importIssues: 'Importación completada con problemas: {summary}. {errors} error(es).',
        importComplete: '¡Importación completa! {summary}',
        importFailed: 'Error al importar: {message}',
        noExportData: 'No hay datos para exportar en este rango de fechas.',
        reportDownloaded: 'Informe de ventas descargado ({format}).',
        exportFailed: 'No se pudo exportar el informe de ventas.',
        addEmail: 'Agregue un correo en el perfil del empleado para enviar informes.',
        addPhone: 'Agregue un teléfono en el perfil del empleado para enviar informes.',
        reportSentEmail: 'Informe de turno enviado a {dest}',
        reportSentPhone: 'Informe de turno enviado a {dest}',
        reportFailed: 'No se pudo enviar el informe de turno.',
        photoFailed: 'No se pudo usar esa foto. Pruebe con una imagen más pequeña.',
    },
    payoutActions: {
        payOutTips: 'Pagar propinas',
        paying: 'Pagando…',
        markPaid: 'Marcar como pagado (manual)',
        markingPaid: 'Marcando como pagado...',
        markPaidSkip: 'Marcar como pagado (omitir)',
        confirmPooled: 'Confirmar pago mancomunado',
        payPooled: 'Pagar parte mancomunada',
        payingPooled: 'Pagando parte mancomunada...',
        retryFailed: 'Reintentar transferencias fallidas',
        retryingFailed: 'Reintentando transferencias fallidas...',
        processing: 'Procesando...',
        reclaimPlatform: 'Recuperando a la plataforma...',
        reclaimTransfer: 'Recuperando y transfiriendo...',
        tryNow: 'Intentar ahora',
        trying: 'Intentando...',
        emailSetup: 'Enviar enlace de alta',
        textSetup: 'Enviar enlace por SMS',
        pendingTransfers: 'Algunas transferencias de este periodo siguen pendientes.',
        platformLiquidity: 'Liquidez de propinas en la plataforma',
        loadingBalances: 'Cargando saldos de la plataforma…',
        available: 'Disponible',
        pending: 'Pendiente',
        openObligations: 'Obligaciones abiertas',
        netExposure: 'Exposición neta',
        netPosition: 'Posición neta',
        held: 'Retenido',
        pooledShareStatus: 'Estado de la parte mancomunada',
        poolShare: 'Parte del fondo',
        payableNow: 'Pagable ahora',
        availableTips: 'Propinas y gratificación disponibles',
        availablePayout: 'Disponible para pago',
        paidToManager: 'Propinas y gratificación pagadas al gerente',
        tipRoutingMode: 'Modo de enrutamiento de propinas',
        designatedRecipient: 'Destinatario designado de propinas',
        tipsOverview: 'Resumen de propinas',
        payoutSuccessful: 'Pago exitoso',
        payoutId: 'ID de pago',
        payoutAmount: 'Importe del pago',
        payoutMethod: 'Método de pago',
    },
    customerScreen: {
        note: 'Nota:',
        noteBody: 'Las imágenes, URL y videos guardados aquí están disponibles para la pantalla del cliente. Las estaciones eligen qué recursos mostrar.',
        websiteUrl: 'URL del sitio',
        websiteName: 'Nombre del sitio',
        saveUrl: 'Guardar URL',
        url: 'URL',
        deleteUrl: '¿Eliminar URL?',
        deleteUrlNamed: '¿Eliminar “{name}”? Esta acción no se puede deshacer.',
        deleteUrlBody: '¿Eliminar esta URL? Esta acción no se puede deshacer.',
        imageName: 'Nombre de la imagen',
        saveImage: 'Guardar imagen',
        deleteImage: '¿Eliminar imagen?',
        deleteImageNamed: '¿Eliminar “{name}”? Esta acción no se puede deshacer.',
        deleteImageBody: '¿Eliminar esta imagen? Esta acción no se puede deshacer.',
        videoName: 'Nombre del video',
        saveVideo: 'Guardar video',
        deleteVideo: '¿Eliminar video?',
        deleteVideoNamed: '¿Eliminar “{name}”? Esta acción no se puede deshacer.',
        deleteVideoBody: '¿Eliminar este video? Esta acción no se puede deshacer.',
        images: 'Imágenes',
        imagesIntro: 'Imágenes disponibles para la pantalla del cliente.',
        replaceImage: 'Reemplazar imagen',
        chooseImage: 'Elegir imagen',
        editImageName: 'Editar nombre de imagen',
        websites: 'Sitios web',
        websitesIntro: 'URL de sitios disponibles para la pantalla del cliente.',
        videos: 'Videos',
        videosIntro: 'Videos disponibles para la pantalla del cliente.',
        replaceVideo: 'Reemplazar video',
        chooseVideo: 'Elegir video',
        editVideoName: 'Editar nombre de video',
        editUrl: 'Editar URL',
        urls: 'URL',
        urlsIntro: 'Páginas web disponibles para la pantalla del cliente.',
        editWebsite: 'Editar sitio',
        replacePoster: 'Reemplazar póster',
        choosePoster: 'Elegir póster',
        poster: 'Póster',
        mp4Only: 'Solo archivos MP4.',
    },
    layouts: {
        title: 'Diseños',
        venuesHeader: 'Salones y diseños',
        venuesIntro: 'Planos de planta disponibles para las estaciones.',
        newVenue: 'Nuevo salón',
        noVenues: 'Aún no hay salones. Cree uno para empezar: cada salón puede tener varios planos que las estaciones POS pueden usar en el modo de diseño.',
        stationHeader: 'Modo de diseño de estación',
        stationIntro: 'Active la vista de diseño por estación.',
        noStations: 'Aún no hay estaciones configuradas.',
        layoutOn: 'Modo de diseño ACTIVADO',
        layoutOff: 'Modo de diseño DESACTIVADO',
        venueOption: '— Salón —',
        layoutOption: '— Diseño —',
        note: 'Nota:',
        noteBody: 'Cuando el modo de diseño está activado, esa estación abre el plano seleccionado en lugar de la cuadrícula de productos. Los operadores también pueden cambiarlo en el dispositivo.',
        inactive: 'inactivo',
        showLayouts: 'Mostrar diseños',
        noLayouts: 'Aún no hay diseños.',
        noLayoutsForVenue: 'Aún no hay diseños activos para este salón. Cree uno en Salones y diseños.',
        layoutAssigned: 'Diseño asignado',
        pickVenueLayout: 'Elija un salón y un diseño antes de activar el modo de diseño.',
        layoutLoading: 'La asignación de diseño aún se está cargando. Inténtelo de nuevo en un momento.',
        layoutSaveFailed: 'La estación se actualizó, pero no se pudo guardar la asignación de diseño. Inténtelo de nuevo.',
        saveLayoutBinding: 'Guardar diseño',
        newLayout: 'Nuevo diseño',
        deactivate: 'Desactivar',
        editVenue: 'Editar salón',
        description: 'Descripción',
        eventVenueId: 'Id de salón de evento (enlace opcional)',
        eventVenuePlaceholder: 'Déjelo en blanco si no lo vincula a un salón de evento Rebelity',
        editLayout: 'Editar diseño',
        newLayoutTitle: 'Nuevo diseño',
        nameRequired: 'Nombre *',
        importFromEventVenue: 'Importar desde salón de evento',
        importFromEventVenueHelp: 'Copia un plano de asientos de taquilla a un nuevo plano POS (solo visual — no sincroniza boletos).',
        importIntro: 'Crea un nuevo diseño POS desde la capa de asientos vinculada. Es una copia visual única. Los ObjectId de boletos no se usan como ids de mesa POS. No se cambian las asignaciones de estación.',
        importSeatingLayer: 'Capa de asientos',
        importLayoutName: 'Nombre del nuevo diseño',
        importDefault: 'predeterminado',
        importNoSeatings: 'No hay capas de asientos activas para este Id de salón de evento.',
        importPreview: 'Vista previa',
        importPreviewing: 'Generando vista previa…',
        importPreviewFailed: 'Falló la vista previa. Los diseños POS existentes no se modificaron.',
        importEmptyMap: 'No se encontró nada asignable. El guardado está bloqueado para no vaciar diseños.',
        importCreate: 'Crear diseño',
        importCommitting: 'Importando…',
        importCommitFailed: 'Falló la importación. Los diseños POS existentes no se modificaron.',
        importMapped: 'Asignados',
        importSkipped: 'Omitidos',
        importConverter: 'Convertidor',
        importSkipReason: 'Omitido {otype} (no compatible con POS)',
    },
    integrations: {
        shopify: 'Shopify',
        shopifyIntro: 'Sincronice las existencias con su tienda en línea. Las categorías y productos solo internos nunca se incluyen.',
        shopifyIntegration: 'Integración de Shopify',
        syncOn: 'Sincronización activa',
        syncPaused: 'Sincronización en pausa',
        connectedDomain: 'Conectado · {domain}',
        location: 'Ubicación',
        mappedSkus: 'SKU asignados',
        lastReconcile: 'Última conciliación',
        openConflicts: 'Conflictos abiertos',
        failedJobs: 'Trabajos de sincronización fallidos',
        lastCatalog: 'Última sincronización de catálogo',
        shopifyLocation: 'Ubicación de Shopify',
        selectLocation: 'Seleccione una ubicación',
        skuMatch: 'Coincidencia de SKU',
        matched: 'Coincidentes',
        unmatched: 'Sin coincidencia',
        unmatchedCollapsed: '{count} artículos de Bistro están ocultos. Expanda para vincularlos.',
        excluded: 'Excluidos (solo internos)',
        linkHelp: 'Vincule un artículo de Bistro a una variante de Shopify no vinculada cuando los SKU no coincidan. Vincular no copia la cantidad.',
        conflicts: 'Conflictos de inventario',
        initialFill: 'Carga inicial',
        fillHelp: 'Copie la cantidad en mano una vez y luego mantenga ambos sistemas sincronizados con ventas y ediciones. Si ambos venden, se combinan los descuentos. Un ajuste explícito usa la edición más reciente; si coinciden en el tiempo, gana la cantidad más baja.',
        fillOnlineToBistro: 'Tienda en línea → Bistro (recomendado)',
        fillBistroToOnline: 'Bistro → tienda en línea',
        fillMatchOnly: 'Solo coincidir — aún no copiar cantidades',
        enableSync: 'Activar sincronización de inventario',
        copyOnlineToBistro: 'Copiar tienda en línea → Bistro',
        copyBistroToOnline: 'Copiar Bistro → tienda en línea',
        pauseSync: 'Pausar sincronización',
        catalog: 'Catálogo (nombre, precio, imagen)',
        catalogHelp: 'Crea productos no vinculados en ambas direcciones y luego copia nombre, precio e imagen de los ya vinculados. Importar catálogo y Copiar catálogo tienda → Bistro crean productos de Bistro desde Shopify (sin vínculos previos). Copiar catálogo Bistro → tienda crea productos de Shopify desde SKU de Bistro no vinculados. Las filas de variación y opción sincronizan nombre y precio; las imágenes aplican al producto principal.',
        importCatalog: 'Importar catálogo desde Shopify',
        importHelp: 'Crea productos de Bistro a partir de productos activos de Shopify que tengan SKU, o vincula esos SKU si ya existen en Bistro. Cada producto va a una categoría de Bistro con el nombre del tipo de producto de Shopify (se crea si falta; sin tipo se usa el valor de reserva abajo). Los ya vinculados se recategorizan igual. El seguimiento de inventario se activa en los importados, también con cantidad 0. Las cantidades disponibles de la ubicación seleccionada se copian a Bistro. Las categorías nuevas se añaden al menú POS predeterminado. Esto no activa la sincronización continua de inventario.',
        importScope: 'Alcance de importación',
        importScopeAll: 'Todas las ubicaciones (catálogo completo)',
        importScopeLocation: 'Ubicación seleccionada',
        importScopeHelp: 'Todas importa cada producto activo de Shopify con SKU. Elegir una ubicación importa solo variantes con stock en esa tienda (nivel de inventario presente; la cantidad puede ser 0).',
        importScopeSummary: 'Alcance: {scope}',
        importSummary: '{shopify} productos de Shopify · se crearán {create} · {variations} variaciones · vincular {link} · omitir {skip}',
        importCategory: 'Categoría de Bistro de reserva (si el tipo de producto de Shopify está vacío)',
        importCategoryDefault: 'Shopify (crear si hace falta)',
        importCategoryCreate: 'Aún no hay categoría. Los tipos de producto vacíos usarán una categoría Shopify.',
        importSimple: 'Crear producto',
        importVariations: 'Crear producto + {count} variaciones',
        importLink: 'Vincular {count} SKU existentes',
        importNow: 'Importar catálogo',
        currencyTitle: 'Moneda del catálogo',
        currencySummary: 'Tienda Shopify: {shop} · Cuenta Bistro: {account}',
        currencyUnknown: 'desconocida',
        fxRate: 'Tipo de cambio Bistro',
        fxRatePlaceholder: 'p. ej. 1,27',
        fxRateHelp: 'Cuántos {account} equivalen a 1 {shop}. La importación multiplica los precios de Shopify por este tipo; la exportación divide.',
        fxRateSave: 'Guardar tipo',
        fxRateSaved: 'Tipo de cambio Bistro guardado.',
        fxRateInvalid: 'Introduzca un tipo mayor que cero.',
        fxRateSaveFailed: 'No se pudo guardar el tipo de cambio Bistro.',
        fxRateRequired: 'Introduzca y guarde un tipo de cambio Bistro antes de importar o copiar precios del catálogo.',
        fxCurrencyUnknown: 'Aún no se detectó la moneda de la tienda. Abra la vista previa de importación o vuelva a conectar Shopify antes de copiar precios.',
        fxNotRequired: 'No hace falta conversión: las monedas coinciden.',
        disconnectShopify: 'Desconectar Shopify',
        connectShopify: 'Conectar Shopify',
        connecting: 'Conectando…',
        helpAria: 'Cómo conectar Shopify e importar el catálogo',
        helpHint: '¿Necesita ayuda? Pulse ? para ver los pasos simples de conexión e importación.',
        helpTitle: 'Conectar Shopify e importar catálogo',
        helpClose: 'Cerrar ayuda',
        helpConnectTitle: 'Conecte su tienda',
        helpConnect1: 'En Shopify, vaya a Ajustes → Apps y canales de venta → Desarrollar apps y cree una app personalizada.',
        helpConnect2: 'Active el acceso a la API de administración para productos, inventario y ubicaciones (lectura y escritura cuando exista). No añada permisos de webhooks.',
        helpConnect3: 'Copie la URL de redirección permitida de abajo y péguela en la app de Shopify. Luego instale la app.',
        helpConnect4: 'Pegue el Client ID, el Client secret y el dominio de la tienda (su-tienda.myshopify.com).',
        helpConnect5: 'Pulse Guardar credenciales y luego Conectar Shopify.',
        helpConnect6: 'Al volver aquí, elija la ubicación de Shopify que tiene el stock.',
        helpImportTitle: 'Importe el catálogo',
        helpImport1: 'Elija la ubicación de Shopify con el stock. La categoría de reserva solo se usa cuando un producto de Shopify no tiene tipo de producto.',
        helpImport2: 'Pulse Importar catálogo. Se crean o vinculan en Bistro los productos activos con SKU según el tipo de producto (se crean categorías si hace falta). Los ya vinculados se recategorizan. Se copian cantidades y se activa el seguimiento de inventario.',
        helpImport3: 'Los productos importados y las categorías nuevas se añaden al menú POS predeterminado (normalmente ALL) para que aparezcan en la caja.',
        helpImport4: 'Cuando quiera que las cantidades se mantengan sincronizadas de forma continua, pulse Activar sincronización de inventario. Para crear productos de Shopify desde artículos de Bistro no vinculados, use Copiar catálogo Bistro → tienda en línea.',
        helpTipsTitle: 'Recuerde',
        helpTip1: 'Cada producto necesita un SKU.',
        helpTip2: 'Los borradores y los artículos sin SKU se omiten.',
        helpTip3: 'La importación copia el stock disponible de la ubicación seleccionada y activa el seguimiento; no activa la sincronización continua de inventario.',
        helpTip4: 'Los SKU que ya existen en Bistro se vinculan y se recategorizan por tipo de producto de Shopify, no se duplican.',
        check: 'Check',
        checkIntro: 'Nómina integrada para esta ubicación. Conectar crea una empresa Check; el firmante autorizado completa Check Onboard (banco, EIN y autorización).',
        checkIntegration: 'Integración de Check',
        connectCheck: 'Conectar Check',
        employees: 'Empleados',
        disconnectConfirm: '¿Desconectar Shopify? El inventario dejará de sincronizarse. Se conservan el Client ID y el secreto.',
    },
};

export default es;
